import React from 'react';
import { Modal, Button, Icon } from 'components';
import styled from 'styled-components';
import { formatPhoneNumber } from 'utils';

interface SendSupraInviteModalProps {
  open: boolean;
  loading: boolean;
  userEmail?: string;
  userPhone?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const SendSupraInviteModal: React.FC<SendSupraInviteModalProps> = ({
  open,
  loading,
  userEmail,
  userPhone,
  onConfirm,
  onCancel,
  confirmText = 'Send Invite',
  cancelText = 'Cancel',
}) => (
    <Modal
      centered
      open={open}
      footer={[
        <Button key="cancel-invite" onClick={onCancel}>
          {cancelText}
        </Button>,
        <Button
          key="send-invite"
          type="primary"
          onClick={onConfirm}
          loading={loading}
        >
          {confirmText}
        </Button>,
      ]}
      width={400}
      onCancel={onCancel}
      onOk={onConfirm}
      confirmLoading={loading}
    >
      <FlexContainer>
        <StyledIcon
          type="antdInfoCircleOutlined"
          color="primary"
          style={{ marginRight: '5px' }}
          width="25px"
        />
        <ModalContent>
          <ModalHeader>Send Supra system invitation?</ModalHeader>
          <ModalBody>
            This will send an invite to{' '}
            {userEmail && <UserContact>{userEmail}</UserContact>}
            {userPhone && (
              <>
                {userEmail && ' and '}
                <UserContact>{formatPhoneNumber(userPhone)}</UserContact>
              </>
            )}{' '}
            where they will need to activate their subscription.
          </ModalBody>
        </ModalContent>
      </FlexContainer>
    </Modal>
  );

const FlexContainer = styled.div`
  display: flex;
`;

const StyledIcon = styled(Icon)`
  margin: 0 10px;
`;

const ModalHeader = styled.div`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
`;

const ModalBody = styled.div`
  color: rgba(0, 0, 0, 0.65);
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.65);
  margin: 0 10px;
  gap: 10px;
`;

const UserContact = styled.span`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
`;

export default SendSupraInviteModal;
